module.exports = __webpack_public_path__ + "static/media/logo.5a04b9c2.svg";